<template>
    <div class="d-flex gap-8px font-roboto">

        <button v-if="false" class="btn btn-outline-primary"  type="button"
            @click="Developer_ChangStatus('PENDING')">
        <span>(Developer) Mark PENDING</span>
        </button>

        <button :class="(IsUnmatchedStatusExist(['PENDING']) ?'btn btn-light' : ' btn btn-primary')"  type="button"
        :disabled="IsUnmatchedStatusExist(['PENDING'])"
        @click="CheckStatus('REVIEW')"
        v-if="isSuperAdmin">
        <span>{{ $t('lbl_EMPBE_ReportAll_Title_Button_MarkReview') }}</span>
        </button>

        <button :class="(IsUnmatchedStatusExist(['REVIEW']) ?'btn btn-light' : ' btn btn-primary')"  type="button"
        :disabled="IsUnmatchedStatusExist(['REVIEW'])"
        @click="CheckStatus('READY')"
        v-if="isSuperAdmin"
        >
        <span>{{ $t('lbl_EMPBE_ReportAll_Title_Button_MarkReady') }}</span>
        </button>

        <button :class="(IsUnmatchedStatusExist(['READY','SENT']) ?'btn btn-light' : ' btn btn-primary')"  type="button"
        :disabled="IsUnmatchedStatusExist(['READY','SENT'])"
        @click="CheckStatus('SENDING')">
        <span>{{ $t('lbl_EMPBE_ReportAll_Title_Button_SendReport') }}</span>
        </button>

        <!--General Status Change-->
        <!--Error!-->
        <DialogModal :id="'StatusError'"  ref="StatusErrorModal"
        @callBackConfirm="GridFilter(GetCorrectStatus)" :ConfirmText="$t(`lbl_EMPBE_ReportAll_component_StatusChange_errorButton`,{strus:$t(`lbl_EMPBE_AutoReport_${GetCorrectStatus}`)})" >
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_errorTitle',{strus:$t(`lbl_EMPBE_AutoReport_${CurStatusCode}`)}) }}
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_errorMsg',{strus:$t(`lbl_EMPBE_AutoReport_${GetCorrectStatus}`)}) }}
                </div>
            </div>
        </DialogModal>

        <!--Confirm-->
        <DialogModal :id="'StatusConfirm'"  ref="StatusConfirmModal" :isOkayOnly="false"
        @callBackConfirm="ChangStatus()" :ConfirmText="$t(`lbl_EMPBE_ReportAll_Title_Button_MarkStrus`,{strus:$t(`lbl_EMPBE_AutoReport_${CurStatusCode}`)})" :CancelText="$t('lbl_EMPBE_ReportAll_component_Cancel')">
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_ChangeTitle',{number:GetSelectedCount,strus:$t(`lbl_EMPBE_AutoReport_${CurStatusCode}`)}) }}
                </div>
                <div class="Modal-TitleDesc">
                    <span v-if="CurStatusCode=='REVIEW'">
                        {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_ChangeFirstMsg',{number:GetSelectedCount}) }}
                        <br/>
                        <br/>
                        {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_ChangeSeconedMsg') }}
                   </span>
                    <span v-if="CurStatusCode=='READY'">
                        {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_ChangeFirstMsg2') }}
                        <br/>
                        <br/>
                        {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_ChangeSeconedMsg2') }}
                    </span>
                   
                </div>
            </div>
            <!-- <template #Confirm>
                    {{`Mark as ${$t(`lbl_EMPBE_AutoReport_${CurStatusCode}`)}`}}
                </template> -->
        </DialogModal>

        <!--Loading-->
        <DialogModal :id="'loading'" :NoDefaultBtn="true" :DisableClickOutSideToClose="LockLoadingScreen" 
        :noFade="true" ref="StatusLoadingModal" >
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle DotLoading">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_CheckingMergeData') }}
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_NoRefreshText') }}
                </div>
            </div>
            <template #ExtraBtn>
                <button :disabled="LockLoadingScreen" class="btn btn-primary" type="button" @click="CloseLoadingModal()">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_Calculating') }}
                 </button>
            </template>
        </DialogModal>

        <!--Success-->
        <DialogModal :id="'StatusChangeSuccess'" ref="StatusSucModal" :isOkayOnly="true" :ConfirmText="$t('lbl_EMPBE_ReportAll_component_Import_OK')">
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_SuccessTitle',{strus:$t(`lbl_EMPBE_AutoReport_${CurStatusCode}`)}) }}
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_SuccessTitle',{number:updatedCount,strus:$t(`lbl_EMPBE_AutoReport_${CurStatusCode}`)}) }}
                </div>
            </div>
        </DialogModal>

        <!--Email Sending-->
        <!--Email Confirm-->
        <DialogModal :id="'SendConfirm'" ref="SendConfirmModal"
        @callBackConfirm="SendReportEmail()" :ConfirmText="$t('lbl_EMPBE_ReportAll_component_StatusChange_SendEmailButton')" :CancelText="$t('lbl_EMPBE_ReportAll_component_Cancel')">
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_SendEmailTitle',{number:GetSelectedCount}) }}
               
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_SendEmailMsg') }}
                    <!-- <br/>
                    <br/>
                    Please note: At this stage, you <b>CANNOT</b> cancel it. Proceed with caution. -->
                </div>
            </div>
            <!-- <template #confrim>
                Send report
            </template> -->
        </DialogModal>
        <!--Email Success-->
        <DialogModal :id="'SendSuc'" ref="SendSucModal"
        :isOkayOnly="true" :ConfirmText="$t('lbl_EMPBE_ReportAll_component_Import_OK')">
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_SuccessSendEmailTitle') }}
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_SuccessSendEmailMsg1',{number:updatedCount}) }}
                    <br>
                    <br>
                    {{ $t('lbl_EMPBE_ReportAll_component_StatusChange_SuccessSendEmailMsg2') }}
                </div>
            </div>
            <!-- <template #confrim>
                Send report
            </template> -->
        </DialogModal>
        <!--Email Resend-->
        <DialogModal :id="'Resend'" ref="ResendConfirmModal"
        @callBackConfirm="SendReportEmail()" :isOkayOnly="false" :ConfirmText="$t('lbl_EMPBE_AutoReport_Resend_Confirm')">
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_AutoReport_Resend_Title') }}
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_AutoReport_Resend_Text') }}
                </div>
            </div>
            <!-- <template #confrim>
                Send report
            </template> -->
        </DialogModal>
    </div>

</template>

<script>

import DialogModal from '../../../components/popup/dialogModal.vue'
import { reportService } from '@/_services/report.service';  

export default{
    components: {
        DialogModal
    },
    props:["SelectedEdition", "GridSearchQuery", "GridSelected", "IsGridSelectedCrossPage" , "GetSelectedCount", "GridSelected_Status"
        ,"isSuperAdmin"
    ],
    data(){
        return {
            ErrorTitle : "",
            ErrorDesc : "",
            CurStatusCode : "",
            updatedCount : 0,
            LockLoadingScreen :  false,
            
        }
    },
    computed:{
        GetCorrectStatus(){
            if(this.CurStatusCode == 'REVIEW'){
                return "PENDING"
            }

            if(this.CurStatusCode == 'READY'){
                return "REVIEW"
            }

            if(this.CurStatusCode == 'SENDING'){
                return "READY"
            }

            return ""
        }

    },
    methods:{
        async MarkReportStatus(param){
            var data;
            this.$emit('SetLoading',true);
            await reportService.MarkReportStatus(param).then( res=>{
                if(res.isSuccessful){
                    data = res.data
                }
            }).finally( _ => {
                this.$emit('SetLoading',false);
                this.$refs.StatusLoadingModal.CloseModal();
            })

            return data;
        },
        async ChangStatus(){

            this.LockLoadingScreen = true;
            this.$refs.StatusConfirmModal.CloseModal()
            this.$refs.StatusLoadingModal.ShowModal();
            var res = await this.MarkReportStatus(this.GetParam(this.CurStatusCode, false));
            this.LockLoadingScreen = false;

            this.$emit('SoftReload');

            if(res.isValid){
                this.updatedCount = res.updatedCount
                this.$refs.StatusSucModal.ShowModal()
            }
        },
        async Developer_ChangStatus(Code){
            var res = await this.MarkReportStatus(this.GetParam(Code, false, true));
            console.log(res)
            this.$emit('SoftReload');
        },
        async CheckStatus(StatusCode){
            this.CurStatusCode = StatusCode

            var res = await this.MarkReportStatus(this.GetParam(StatusCode, true));

            if(!res.isValid){
                    this.$refs.StatusErrorModal.ShowModal();
            }else{
                
                const HaveSentStatus =  this.GridSelected_Status.find( x => x == "SENT")
                console.log(HaveSentStatus, this.GridSelected_Status)
                StatusCode != "SENDING" ? this.$refs.StatusConfirmModal.ShowModal() : 
                HaveSentStatus ? this.$refs.ResendConfirmModal.ShowModal() :
                this.$refs.SendConfirmModal.ShowModal() ;             
            }

        },
        GetParam(StatusCode,IsCheckValidOnly, IsBypassValidation){
            return {
                batchid : this.SelectedEdition,
                DelimitedCompanyId : this.GridSelected.join(','),
                StatusCode : StatusCode,
                gridSearchParam : this.IsGridSelectedCrossPage ?  this.GridSearchQuery : null, //for cross-page batch process
                IsCheckValidOnly : IsCheckValidOnly,
                IsBypassValidation : IsBypassValidation
            }
        },
        IsUnmatchedStatusExist(StatusCode){
            return !this.GridSelected_Status.length || this.GridSelected_Status.find( x => !StatusCode.includes(x))
        },
        CloseLoadingModal(){
            //In case the Loading modal is not closed by program
            this.$refs.StatusLoadingModal.CloseModal();
        },
        GridFilter(Status){
            this.$emit('GridFilter',Status)
            this.$refs.StatusErrorModal.CloseModal();
        },
        async SendReportEmail(){
            var EmailParam = {
                BatchId : this.SelectedEdition,
                DelimitedCompanyId : this.GridSelected.join(','),
                gridSearchParam :  this.IsGridSelectedCrossPage ?  this.GridSearchQuery : null, //for cross-page batch process
            }
            var res = await reportService.SendReportEmail(EmailParam);
            if(res.isSuccessful){
                console.log(res)
                console.log(res.data.result.length)
                this.updatedCount = res.data.result.length;
                this.$refs.SendSucModal.ShowModal();    
            }
            this.$refs.SendConfirmModal.CloseModal();    
            this.$refs.ResendConfirmModal.CloseModal();
            this.$emit('SoftReload');
        }
    }
}
</script>
<style lang="css" scoped>
    .BtnDisabled
    {
        background-color:#ccc !important;
    }
    .btn-light.disabled, .btn-light:disabled
    {

        background-color: #CCCCCC !important;
    }
    .btn-light {
        color: #FFFFFF !important;
    }
</style>